const PUBLIC_SITE_URL = (
  process.env.REACT_APP_PUBLIC_SITE_URL || 'https://bpafinancialreports.onrender.com'
).replace(/\/$/, '');

export const SOCIAL_LINKS = [
  {
    id: 'instagram',
    label: 'Instagram',
    href: process.env.REACT_APP_INSTAGRAM_URL || 'https://www.instagram.com/bautistaplanning/',
  },
  {
    id: 'tiktok',
    label: 'TikTok',
    href: process.env.REACT_APP_TIKTOK_URL || 'https://www.tiktok.com/@bautistaplanning',
  },
  {
    id: 'threads',
    label: 'Threads',
    href: process.env.REACT_APP_THREADS_URL || 'https://www.threads.net/@bautistaplanning',
  },
].filter((item) => Boolean(item.href));

const CALCULATOR_SEO = {
  '/calculators': {
    title: 'Free Financial Planning Calculators | Bautista Planning',
    description: 'Explore free calculators for housing, taxes, retirement, Social Security, IRAs, vehicle decisions, and investment performance.',
  },
  '/calculators/rent-vs-buy': {
    title: 'Rent vs. Buy Calculator | Bautista Planning',
    description: 'Compare renting versus buying a home, including down payments, mortgage costs, investing, and extra payments.',
  },
  '/calculators/car-lease-vs-buy': {
    title: 'Car Lease vs. Buy Calculator | Bautista Planning',
    description: 'Compare leasing versus buying a vehicle, including payments, fees, interest, equity, and estimated break-even timing.',
  },
  '/paycheck-tax-estimator': {
    title: 'Paycheck Tax Withholding Estimator | Bautista Planning',
    description: 'Estimate whether paycheck withholding is keeping up with household income and tax complexity before filing season.',
  },
  '/retirement-gap-estimator': {
    title: 'Retirement Savings Gap Calculator | Bautista Planning',
    description: 'Estimate whether your current savings pace is aligned with your retirement income goal and identify a potential funding gap.',
  },
  '/roth-vs-traditional-calculator': {
    title: 'Roth vs. Traditional IRA Calculator | Bautista Planning',
    description: 'Compare Roth and Traditional IRA tax tradeoffs now and in retirement using your assumptions.',
  },
  '/social-security-estimator': {
    title: 'Social Security Claiming Calculator | Bautista Planning',
    description: 'Compare Social Security claiming ages and estimate lifetime benefit tradeoffs with an educational planning calculator.',
  },
  '/investment-performance-explorer': {
    title: 'Investment Performance Calculator | Bautista Planning',
    description: 'Explore historical asset-class returns and trailing performance using educational market proxies.',
  },
};

const PATH_ALIASES = {
  '/calculators/housing': '/calculators/rent-vs-buy',
  '/housing-decision-calculator': '/calculators/rent-vs-buy',
  '/rent-vs-buy-housing-calculator': '/calculators/rent-vs-buy',
  '/linktree': '/links',
};

const GENERAL_SEO = {
  '/links': {
    title: 'Financial Planning for High Earners | Bautista Planning',
    description: 'Get a comprehensive financial plan or use free financial planning calculators for taxes, retirement, housing, and investing.',
  },
  '/goal-setting-meeting': {
    title: 'Goal-Setting Meeting | Bautista Planning',
    description: 'A 60-minute paid first meeting to get clear on your goals and how financial planning frameworks apply to you, before deciding on a comprehensive plan.',
  },
  '/financial-planning-services/request-meeting': {
    title: 'Get Started With Your Financial Plan | Bautista Planning',
    description: 'Share a few details about your household, priorities, and financial questions so the planning process can begin with the right context.',
  },
  '/financial-planning-services': {
    title: 'Financial Planning Services & Pricing | Bautista Planning',
    description: 'Create a comprehensive financial plan, then add ongoing financial planning support when you want help implementing it.',
  },
};

export function getPublicSeo(pathname) {
  const canonicalPath = PATH_ALIASES[pathname] || pathname;
  const metadata = CALCULATOR_SEO[canonicalPath] || GENERAL_SEO[canonicalPath];
  if (!metadata) return null;

  return {
    ...metadata,
    canonicalPath,
    canonicalUrl: `${PUBLIC_SITE_URL}${canonicalPath}`,
    isCalculator: Boolean(CALCULATOR_SEO[canonicalPath] && canonicalPath !== '/calculators'),
  };
}

export { PUBLIC_SITE_URL };
